import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SearchCards from "components/TripCard/SearchCards";
import { Helmet } from "react-helmet";

const RecentOpenTrips = () => {
    return (<div className="nc-PageHome relative overflow-hidden">
        <Helmet>
            <title>Recent Open Trips</title>
        </Helmet>
        <BgGlassmorphism />
        <div className="container relative md:mb-24 lg:mb-32">
            <div className="relative">
                <BackgroundSection />
                <BgGlassmorphism />
                <SearchCards country={{ reset: true, recent: true }} />
            </div>
        </div>

    </div>);
}

export default RecentOpenTrips;